// Single source of truth for cluster topology + shared color helpers.
// Must stay in sync with backend monitor.py CLUSTERS — ideally served via
// /api/topology in the future.

export const ALL_NODES = [
  "node9", "node10", "node11", "node12", "node13",
  "node14", "node15", "node16", "node17",
];

export const NODE_COUNT = ALL_NODES.length;

export const NODES_WITH_40G = new Set(ALL_NODES);

// The 4 disjoint 2-node base clusters that match the Submit page profiles A-D,
// plus node17 as the dedicated map-data server. Larger submit profiles
// E(9-13)/F(9-12)/G(13-16) are spans of these (submit-only). Keep in sync with
// monitor.py CLUSTERS (served via /api/topology).
export const CLUSTERS = {
  A: {
    head: "node9",
    members: ["node9", "node10"],
    label: "Cluster A",
    color: "#22d3ee",
    role: "solver",
  },
  B: {
    head: "node11",
    members: ["node11", "node12"],
    label: "Cluster B",
    color: "#a78bfa",
    role: "solver",
  },
  C: {
    head: "node13",
    members: ["node13", "node14"],
    label: "Cluster C",
    color: "#4ade80",
    role: "solver",
  },
  D: {
    head: "node15",
    members: ["node15", "node16"],
    label: "Cluster D",
    color: "#fb923c",
    role: "solver",
  },
  P: {
    head: "node17",
    members: ["node17"],
    label: "MAP-DATA SERVER",
    color: "#94a3b8",
    role: "postproc",
  },
};

export const NODE_TO_CLUSTER = Object.fromEntries(
  Object.entries(CLUSTERS).flatMap(([id, c]) =>
    c.members.map((n) => [n, id])
  )
);

// ===== Shared color helpers =====
export const cpuColor = (v) =>
  v >= 90 ? "#ef4444" : v >= 70 ? "#f97316" : "#22c55e";

export const memColor = (v) =>
  v >= 90 ? "#ef4444" : v >= 75 ? "#eab308" : "#22c55e";

export const bwColor = (g) =>
  g >= 25 ? "#22c55e" : g >= 10 ? "#eab308" : g > 0 ? "#3b82f6" : "#4b5563";
